import { useFetchFromPublicWabunkaApi } from '@/composables/useFetchFromPublicWabunkaApi';
import { fromStaticMapUrlJson } from '@/wabunka-src/features/Experience/composables/query/internal/locationDetailsResponse';

/**
 * 体験詳細「Location Details」モーダル用 — Static マップの署名付き URL を wabunka-backend（E-3）から取得する。
 *
 * API キー・署名シークレットを frontend に出さないため backend が署名した URL を受け取り `<img>` で表示する。
 * モーダル開封時のみ発行・課金する方針のため `immediate: false` の遅延取得とし、開封時に `execute()` を呼ぶ。
 * 座標なしの体験は空文字（マップ非表示）。
 */
export const useStaticMapUrlQuery = (experienceId: Ref<string>) => {
  const path = computed(() => `/experiences/${experienceId.value}/staticMapUrl`);

  const { data, status, error, execute } = useFetchFromPublicWabunkaApi({
    path,
    options: { server: false, immediate: false, lazy: true },
    converter: fromStaticMapUrlJson,
  });

  const staticMapUrl = computed<string>(() => data.value?.url ?? '');

  return { staticMapUrl, status, error, execute };
};
